<template>
  <div class="pc-competition">
    <BreadCrumb :data="breadcrumb" :title="'词库列表管理'" />
    <SensitiveWordManagementTable
      :title="titles"
      class="pc-news-tab"
      @addTopic="addTopic"
      @deleteTopic="deleteTopic"
      @search="search"
    />
    <div class="pc-competition-table">
      <thesaurusManagementTable />
    </div>
  </div>
</template>
<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import SensitiveWordManagementTable from "./components/SensitiveWordManagementTable";
import thesaurusManagementTable from "../content/components/thesaurusManagementTable";

import {
  stopWordLibrary_Api,
  createStopWordLibrary_Api,
  deleteStopWordLibrary_Api,
} from "@/apis/word.api";
export default {
  components: {
    BreadCrumb,
    thesaurusManagementTable,
    SensitiveWordManagementTable,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "词库列表", link: "/admin/thesaurusManagement" },
      ];
    },
  },
  data() {
    return {
      titles: {
        module: "敏感",
        class: [{ name: "", subTitles: [] }],
      },
      count: 0,
      searchRules: {
        keyword: "",
      },
    };
  },
  mounted() {
    this.competitionTopicSearch();
  },
  methods: {
    addTopic(topic, callback) {
      console.log(topic);
      if (topic.type == "") {
        createStopWordLibrary_Api({
          stop_word: topic.stop_word,
        }).then(() => {
          callback();
          this.competitionTopicSearch();
        });
      }
    },
    deleteTopic(topic, callback) {
      if (topic.type == "") {
        deleteStopWordLibrary_Api({
          stop_word_id: topic.id,
        }).then(() => {
          callback();
          this.competitionTopicSearch();
        });
      }
    },
    competitionTopicSearch() {
      stopWordLibrary_Api(this.searchRules.keyword).then((res) => {
        this.$set(this.titles.class[0], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.competitionTopicSearch();
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.keyword) {
        data.keyword = formData.keyword;
      }
      return data;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/content/thesaurusManagement.vue